var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"social-auth-nav"},[_c('li',[_c('div',{attrs:{"provider":"facebook"},on:{"click":function($event){return _vm.social('facebook')}}},[_vm._v("Facebook")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }